import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'bcJoinTruthy' })
export class JoinTruthyPipe implements PipeTransform {
  transform(values: (string | null | undefined)[], separator = ', '): string {
    return values.filter(Boolean).join(separator);
  }
}
